import PropTypes from 'prop-types';
import {
  TextInput,
  ActionIcon,
  Group,
  Stack,
} from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { joinFileName, splitFileName } from '@/helpers/string';

const EditFiles = (props) => {
  const { files, onNameChange, onRemove } = props;

  if (!files || files.length === 0) return null;

  return (
    <Stack spacing='xs' mt='sm'>
      {files.map((file, index) => {
        const { baseName, extension } = splitFileName(file.name);

        return (
          <Group key={index} spacing='xs' noWrap>
            <TextInput
              value={baseName}
              onChange={(e) => onNameChange(index, joinFileName(e.target.value, extension))}
              size='sm'
            />
            <ActionIcon
              color='red'
              variant='light'
              onClick={() => onRemove(index)}
              size='sm'
            >
              <IconTrash size={16} />
            </ActionIcon>
          </Group>
        );
      })}
    </Stack>
  );
};

EditFiles.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string.isRequired }),
  ),
  onNameChange: PropTypes.func,
  onRemove: PropTypes.func,
};

export default EditFiles;
